<template>
    <EditCreance />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import EditCreance from "@/components/GesCom/Creance/EditCreance.vue";
  
    export default defineComponent({
      name: "EditCreancePage",
      components: {
        
        EditCreance,
      },
    });
  </script>